import React, { Component } from 'react';
import './style.css';
import { HeaderQuestion, NextQuestionButton } from '../../components';
import { Trans, translate } from 'react-i18next';

class Term extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    const { t } = this.props;
    let description = '-';
    let text = '-';
    const name1 = this.props.pair.projectObjects[0].name;
    const name2 = this.props.pair.projectObjects[1].name;
    const maxLength = this.props.maxLength;
    if (this.props.adjective === 'similar') {
      description = (
        <Trans i18nKey="similar">
          In which way are "{{ name1 }}" and "{{ name2 }}" similar?
        </Trans>
      );
      text = t(
        'Please describe one similarity you consider important using 3 words max.'
      );
    }
    if (this.props.adjective === 'different') {
      description = (
        <Trans i18nKey="different">
          In which way are "{{ name1 }}" and "{{ name2 }}" different?
        </Trans>
      );
      text = t(
        'Please describe one characteristic which applies to only one of the objects 3 words max.'
      );
    }
    return (
      <div className="card-body">
        <form onSubmit={this.handleSubmit}>
          <HeaderQuestion
            description={description}
            text={text}
            skip={this.props.skip}
            pairId={this.props.pair.pairId}
          />
          <div className="App-answer-instructions">
            <Trans i18nKey="maxLetters">Max. {{ maxLength }} letters:</Trans>
          </div>
          <div className="input-group App-answer-text App-answer">
            <input
              autoFocus
              type="text"
              className="form-control"
              onChange={this.handleChange}
              value={this.state.value}
              maxLength={this.props.maxLength}
            />
          </div>
          <NextQuestionButton
            to={this.props.url + '/opposite'}
            onClick={() => this.props.save(this.state.value)}
            disabled={this.state.value ? false : true}
          />
        </form>
      </div>
    );
  }
}

export default translate('translations')(Term);



// WEBPACK FOOTER //
// ./src/comparison/components/Pair/term.js